/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'graphs': {
    width: 40,
    height: 37,
    viewBox: '0 0 40 37',
    data: '<path pid="0" class="st0" d="M5.5 31.2H0v-2h4.5L7.9 25h4.2l3.3 3.3h4.2l6.7-6.6h5.6l2.5-4.2H40v2h-4.4l-2.5 4.2h-6l-6.7 6.6h-5.8L11.3 27H8.8zM0 34.2h40v2H0z"/><path pid="1" class="st0" d="M24.3 22.7h-2V11.2h-4.6v6.5h-2V9.2h8.6zM31.033 35.167h-2v-10h2v10zm-6.7 0h-2v-5.8h2v5.8z"/><path pid="2" class="st0" d="M31 20.2h-2v-5.7h-5.7v-2H31zM15.7 31.8h2v3.3h-2zM17.7 26.8h-2v-8.1H10v-2h7.7zM11.033 35.2h-2v-6.7h2v6.7zm-6.7 0h-2v-2.5h2v2.5z"/><path pid="3" class="st0" d="M4.3 27.7h-2V13.3H11v10.2H9v-8.2H4.3z"/><g><path pid="4" class="st0" d="M35.7 21h2v14.2h-2zM37.7 16h-2V2H31v11.5h-2V0h8.7z"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/graphs.js